<template>
  <div
      class="tn-travel-pagination"
  >
    <div class="flex-row">
      <div v-if="getPaged.total > 0" class="text">Reise {{page_start}} bis {{page_end}} von {{ this.getPaged.total }}</div>
      <template v-if="getPaged.total > getPaged.page_size">
        <button
            v-if="1 < getPaged.page_num"
            type="button"
            class="btn-prev"
            @click="gotoPage(getPaged.page_num - 1)"
            :disabled="getPaged.page_num === 1"
        ><i class="eicon-angle-left"></i></button>
        <span v-if="pageLowerBound > 1" class="ellipsis"><i class="eicon-ellipsis-h"></i></span>
        <button
            v-for="pageNum in pageRange"
            :key="pageNum"
            type="button"
            @click="getPaged.page_num !== pageNum && gotoPage(pageNum)"
            class="btn-page"
            :class="{ 'active': getPaged.page_num === pageNum }"
        ><span>{{ pageNum }}</span></button>
        <span v-if="pageUpperBound < pageCount" class="ellipsis"><i class="eicon-ellipsis-h"></i></span>
        <button
            v-if="getPaged.page_num < pageCount"
            type="button"
            class="btn-next"
            @click="gotoPage(getPaged.page_num + 1)"
            :disabled="getPaged.page_num === pageCount"
        ><i class="eicon-angle-right"></i></button>
      </template>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import $ from 'jquery';

export default {
  name: "TnTravelPagination",
  data: () => ({}),
  computed: {
    ...mapGetters(['getPaged']),

    page_start() {
        return Math.max(0, (this.getPaged.page_num - 1) * this.getPaged.page_size + 1);
    },

    page_end() {
      return Math.min(this.getPaged.page_num * this.getPaged.page_size, this.getPaged.total);
    },

    pageCount() {
      return Math.ceil(this.getPaged.total / this.getPaged.page_size);
    },

    pageLowerBound() {
      // 1..(total-4)
      const max = Math.max(1, this.pageCount - 4);
      return Math.min(Math.max(1, this.getPaged.page_num - 2), max);
    },

    pageUpperBound() {
      return Math.min(this.pageLowerBound + 4, this.pageCount);
    },

    pageRange() {
      const pageRange = [];
      for (let page = this.pageLowerBound; page <= this.pageUpperBound; page++) {
        pageRange.push(page);
      }
      return pageRange;
    }

  },
  methods: {
    ...mapActions(['setPage']),

    gotoPage(page) {
      this.setPage(page).then(() => {
        var $el = $(this.$el.parentElement.parentElement);
        $('body, html').animate({
          scrollTop: $el.offset().top - 100
        }, 800);
      });
    }
  }
}
</script>

<style scoped lang="scss">

.tn-travel-pagination {
  padding: 5px 10px;
  background: #910a0a;
  color: #fff;
  margin-bottom: 15px;

  .ellipsis {
    font-size: 24px;
    color: #ea7819;
  }

  .flex-row {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    margin: -5px 0 0 -5px;

    &>.flex-row {
      margin-top: 0;
      margin-left: 0;
    }

    & > * {
      margin-left: 5px;
      margin-top: 5px;
    }
  }

  .text {
    flex: 1 1 auto;
    align-self: center;
    font-size: 14px;
    font-weight: 600;
  }

  button {
    width: 48px;
    padding: 0;
    line-height: 32px;
    color: #ea7819;
    text-align: center;
    font-weight: 400;
    font-size: 1em;
    background-color: transparent;
    border: 1px solid #ea7819;
    cursor: pointer;

    &.active {
      background-color: #ea7819;
      color: #fff;
    }

    &.btn-next,
    &.btn-prev {
      font-size: 24px;
    }
  }

}

tn-travel-touristik-teaser__footer .tn-travel-pagination {
  margin-bottom: 0;
  margin-top: 15px;
}

@media screen and (max-width: 576px) {
  .btn-page, .ellipsis {
    display: none;
  }
}

</style>
